import { render, staticRenderFns } from "./OperaWorkorderDetailDcaInfoWindow.vue?vue&type=template&id=50d381d3&scoped=true&"
import script from "./OperaWorkorderDetailDcaInfoWindow.vue?vue&type=script&lang=js&"
export * from "./OperaWorkorderDetailDcaInfoWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaWorkorderDetailDcaInfoWindow.vue?vue&type=style&index=0&id=50d381d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d381d3",
  null
  
)

export default component.exports